import { useContext } from 'react';
import { ReactReduxContext } from 'react-redux';
import getInjectors from '../../utils/reducerInjectors';
import { useInjectSaga } from '../../utils/injectSaga';
import reducer from './reducer';
import saga from './saga';

/**
 * Registers the kAI reducer synchronously before child hooks/effects run.
 * useInjectReducer schedules injection in useEffect, which runs after
 * KaiChat's init effect — so the first businessId / message patches can be
 * dropped on a cold drawer open.
 */
export default function useKaiStore() {
  const { store } = useContext(ReactReduxContext);
  getInjectors(store).injectReducer('kai', reducer);
  useInjectSaga({ key: 'kai', saga });
}
